import React from 'react';
import { useAuth } from '../provider/authProvider';

export const TopBar: React.FC = () => {
  const { getCurrentUser, clearToken } = useAuth();
  const user = getCurrentUser();

  const handleLogout = () => {
    clearToken();
    window.location.href = '/login';
  };

  return (
    <div style={{
      height: '70px',
      backgroundColor: '#1e293b',
      borderBottom: '1px solid #334155',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 30px',
      position: 'fixed',
      top: 0,
      left: '250px',
      right: 0,
      zIndex: 100
    }}>
      {/* Page Title */}
      <div>
        <h2 style={{
          margin: 0,
          fontSize: '20px',
          color: 'white',
          fontWeight: '600'
        }}>
          Admin Dashboard
        </h2>
      </div>

      {/* User Info & Logout */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
      }}>
        {/* User Info */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>
          <span style={{
            color: 'white',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            {user?.firstName} {user?.lastName}
          </span>
          <span style={{
            color: '#94a3b8',
            fontSize: '12px'
          }}>
            {user?.email}
          </span>
          <span style={{
            color: '#3b82f6',
            fontSize: '11px',
            fontWeight: '600',
            marginTop: '2px'
          }}>
            {user?.role}
          </span>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          style={{
            padding: '10px 20px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#dc2626';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ef4444';
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};
